import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import TerminalTable from '@payment-terminals/components/tables/terminal-table/terminal-table.vue';

@Component({
  name: 'bpc-terminals',
  components: {
    'bpc-terminal-table': TerminalTable,
  },
})
export default class Terminals extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
